@Service('ib-http-services-module',
    [
        '$q',
        '$filter',
        'HttpServicesConstants',
        'localStorageService',
        'CommonsGenericProxy',
        'CommonsHttpUtilsErrorService',
        '$timeout'
    ])
class TravelInfoService {
    public counterAttemps: number;
    constructor (
        private $q: ng.IQService,
        private $filter: angular.IFilterService,
        private HttpServicesConstants: HttpServicesConstantsNamespace.HttpServicesConstants,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CommonsGenericProxy: CommonsGenericProxy,
        private CommonsHttpUtilsErrorService: CommonsHttpUtilsErrorService,
        private $timeout: ng.ITimeoutService
    ) {
        this.counterAttemps = 0;
    }
    /**
     * Send to service travel info the documents saved for user in form of APIS
     * @param {Object} passenger Passenger information with documents
     */
    saveTravelInfo = (passenger: any, deferredRecall?: any): angular.IPromise<unknown> => {
        let defer = deferredRecall || this.$q.defer();
        const checkinId = this.localStorageService.get('flowId');
        const endpoint = this.HttpServicesConstants.URI.DEFAULT_ENDPOINTS.travelInfoServiceURI;

        const saveTravelInfoError = (error): void => {
            this.CommonsHttpUtilsErrorService.controlError(error, this.counterAttemps, saveTravelInfoCallback, defer);
        };
        const saveTravelInfoCallback = () => {
            this.counterAttemps++;
            this.saveTravelInfo(passenger, defer);
        };
        const saveTravelInfoSuccess = (data) => {
            defer.resolve(data);
            defer = null;
        };
        if (checkinId !== null) {
            this.CommonsGenericProxy.putGeneric(endpoint, passenger)
                .then(saveTravelInfoSuccess, saveTravelInfoError).catch(saveTravelInfoError);
        } else {
            this.$timeout(() => {
                defer.reject({ errorCode: 'IB_00002', message: this.$filter('translate')('SESSION_EXPIRED'), internalErrorCode: 'IB_00002' });
                defer = null;
            });
        }
        return defer.promise;
    };

    /**
     * Get the documents saved for the passenger
     */
    getTravelInfo = (deferredRecall?: any): angular.IPromise<unknown> => {
        let defer = deferredRecall || this.$q.defer();
        const checkinId = this.localStorageService.get('flowId');
        const endpoint = this.HttpServicesConstants.URI.DEFAULT_ENDPOINTS.travelInfoServiceURI;

        const getTravelInfoError = (error): void => {
            this.CommonsHttpUtilsErrorService.controlError(error, this.counterAttemps, getTravelInfoCallback, defer);
        };
        const getTravelInfoCallback = () => {
            this.counterAttemps++;
            this.getTravelInfo(defer);
        };
        const getTravelInfoSuccess = (data) => {
            defer.resolve(data.data);
            defer = null;
        };
        if (checkinId !== null) {
            this.CommonsGenericProxy.getGeneric(endpoint)
                .then(getTravelInfoSuccess, getTravelInfoError).catch(getTravelInfoError);
        } else {
            this.$timeout(() => {
                defer.reject({ errorCode: 'IB_00002', message: this.$filter('translate')('SESSION_EXPIRED'), internalErrorCode: 'IB_00002' });
                defer = null;
            });
        }
        return defer.promise;
    };

    /**
     * Get the documents saved for the passenger
     */
    deleteTravelInfo = (deferredRecall?: any): angular.IPromise<unknown> => {
        let defer = deferredRecall || this.$q.defer();
        const endpoint = this.HttpServicesConstants.URI.DEFAULT_ENDPOINTS.travelInfoServiceURI;

        const deleteTravelInfoError = (error): void => {
            this.CommonsHttpUtilsErrorService.controlError(error, this.counterAttemps, deleteTravelInfoCallback, defer);
        };
        const deleteTravelInfoCallback = () => {
            this.counterAttemps++;
            this.deleteTravelInfo(defer);
        };
        const deleteTravelInfoSuccess = (data) => {
            defer.resolve(data.data);
            defer = null;
        };
        this.CommonsGenericProxy.deleteGeneric(endpoint)
            .then(deleteTravelInfoSuccess, deleteTravelInfoError).catch(deleteTravelInfoError);
        return defer.promise;
    };
}